import axios, { type AxiosError, type AxiosInstance } from "axios";
import { getCookie } from "cookies-next";
import { dateInterceptor } from "./date.interceptor";
import { errorMiddleware } from "./middleware/middleware";

const TOKEN_COOKIE_NAME = "te_studyguide_token";
export const axiosInstance: AxiosInstance = axios.create({
  withCredentials: true,
  headers: {
    common: {
      "x-xsrf-token": getCookie("XSRF-TOKEN")
    }
  },
  paramsSerializer: (params) => {
    const parameters = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((singularValue) => {
          parameters.append(key, singularValue);
        });
        return;
      }

      parameters.append(key, value);
    });

    return parameters.toString();
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getCookie(TOKEN_COOKIE_NAME);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

// axiosInstance.interceptors.response.use(undefined, authInterceptor);
axiosInstance.interceptors.response.use(undefined, errorMiddleware);
axiosInstance.interceptors.response.use(dateInterceptor);
